import PageGenerate from './PageGenerate.js';

let _esgAward = {};
let _esgArticle = {};
let _esgDownload = {};


_esgAward.data = {};
_esgAward.init = function(){
    $('.bkAwardSession').each(function(){
        const _id = $(this).attr('data-id');
        if(_esgAward.data[_id]==undefined) _esgAward.data[_id] = [];
        _esgAward.data[_id].push($(this).clone());
    });
    if(Object.keys(_esgAward.data).length==0){
        return
    }
    _esgAward.awardSessionClick();

    $('.bkAwardList').empty();
    const _id = $('.bkAwardSessionOption').eq(0).attr('data-id');
    _esgAward.data[_id].forEach(function(val){
        $('.bkAwardList').append(val);
    })
    _g.collapseUpdate();
}
_esgAward.awardSessionClick = function(){
    $('.bkAwardSessionOption').on('click',function(){
        $('.bkAwardList').empty();
        const _id = $(this).attr('data-id');
        _esgAward.data[_id].forEach(function(val){
            $('.bkAwardList').append(val);
        })
        _g.collapseUpdate();
    });
}
////////////////////////////////////////////////////

_esgArticle.paginationDesk = $('.bkArticlePage .bkDeskPagination').val()*1;
_esgArticle.paginationMob = $('.bkArticlePage .bkMobPagination').val()*1;
_esgArticle.pagination = $('.bkArticlePage .bkDeskPagination').val()*1;
_esgArticle.dataCount = $('.bkArticlePage .bkDataCount').val()*1;
_esgArticle.pageCount = 0;
_esgArticle.pageNow = 1;
_esgArticle.firstTime = 1;

_esgArticle.pageInit = function(){
    _esgArticle.pageCount = Math.ceil(_esgArticle.dataCount/_esgArticle.pagination);
    _esgArticle.changeData();
}

_esgArticle.pagePrev = function(){
    $('.bkArticlePage .bkPrev').on('click',function(){
        _esgArticle.pageNow = _esgArticle.pageNow - 1;
        _esgArticle.changeData();
    });
}

_esgArticle.pageNext = function(){
    $('.bkArticlePage .bkNext').on('click',function(){
        _esgArticle.pageNow = _esgArticle.pageNow + 1;
        _esgArticle.changeData();
    });
}

_esgArticle.pageClick = function(){
    $('.bkArticlePage .bkPage').on('click',function(){
        _esgArticle.pageNow = $(this).attr('data-page')*1;
        _esgArticle.changeData();
    });
}

_esgArticle.changeData = function(){
    const _min = (_esgArticle.pageNow-1)*_esgArticle.pagination-1;
    const _max = _esgArticle.pageNow*_esgArticle.pagination;
    $('.bkArticle').hide();
    if(_min==-1){
        $(`.bkArticle:lt(${_max})`).show();
    }
    $(`.bkArticle:lt(${_max}):gt(${_min})`).show();
    _g.aost4.update();
    if(_esgArticle.firstTime==0){
        Anchor4.run({
            target: '.block[data-type="news"]',
            delay: 300,
        })
    }
    _esgArticle.firstTime = 0;
    _esgArticle.pageGenerate(_esgArticle.pageNow);
}

_esgArticle.pageGenerate = function(position){
    const pageG = new PageGenerate(_esgArticle.pageCount,position);
    $('.bkArticlePage').html(pageG.html);
    $(`.bkArticlePage .bkPage[data-page="${_esgArticle.pageNow}"]`).addClass('active');
    _esgArticle.bindBtn();
}

_esgArticle.bindBtn = function(){
    _esgArticle.pagePrev();
    _esgArticle.pageNext();
    _esgArticle.pageClick();
}

////////////////////////////////////////////////////

_esgDownload.pagination = $('.bkDownloadPage .bkPagination').val()*1;
_esgDownload.dataAllCount = $('.bkDownloadPage .bkDataCount').val()*1;
_esgDownload.dataCount = $('.bkDownloadPage .bkDataCount').val()*1;
_esgDownload.pageCount = 0;
_esgDownload.pageNow = 1;
_esgDownload.year = 'all';

_esgDownload.yearClick = function(){
    $('.bkDownloadYear').on('click',function(){
        _esgDownload.year = $(this).attr('data-year');
        if(_esgDownload.year=='all') _esgDownload.dataCount =_esgDownload.dataAllCount;
        else _esgDownload.dataCount = $(`.bkDownloadItem[data-year="${_esgDownload.year}"]`).length;
        _esgDownload.pageCount = Math.ceil(_esgDownload.dataCount/_esgDownload.pagination);
        _esgDownload.pageNow = 1;
        _esgDownload.changeData();
    });
}
_esgDownload.pageInit = function(){
    _esgDownload.pageCount = Math.ceil(_esgDownload.dataCount/_esgDownload.pagination);
    _esgDownload.yearClick();
    _esgDownload.changeData();
}

_esgDownload.pagePrev = function(){
    $('.bkDownloadPage .bkPrev').on('click',function(){
        _esgDownload.pageNow = _esgDownload.pageNow - 1;
        _esgDownload.changeData();
    });
}

_esgDownload.pageNext = function(){
    $('.bkDownloadPage .bkNext').on('click',function(){
        _esgDownload.pageNow = _esgDownload.pageNow + 1;
        _esgDownload.changeData();
    });
}

_esgDownload.pageClick = function(){
    $('.bkDownloadPage .bkPage').on('click',function(){
        _esgDownload.pageNow = $(this).attr('data-page')*1;
        _esgDownload.changeData();
    });
}

_esgDownload.changeData = function(){
    const _min = (_esgDownload.pageNow-1)*_esgDownload.pagination-1;
    const _max = _esgDownload.pageNow*_esgDownload.pagination;
    $('.bkDownloadItem').removeClass('even').removeClass('odd').hide();
    if(_esgDownload.year=='all'){
        if(_min==-1){
            $(`.bkDownloadItem:lt(${_max}):even`).addClass('odd').show();
            $(`.bkDownloadItem:lt(${_max}):odd`).addClass('even').show();
        }
    $(`.bkDownloadItem:lt(${_max}):gt(${_min}):even`).addClass('odd').show();
    $(`.bkDownloadItem:lt(${_max}):gt(${_min}):odd`).addClass('even').show();
    }
    else{
        if(_min==-1){
            $(`.bkDownloadItem[data-year="${_esgDownload.year}"]:lt(${_max}):even`).addClass('odd').show();
            $(`.bkDownloadItem[data-year="${_esgDownload.year}"]:lt(${_max}):odd`).addClass('even').show();
        }
        $(`.bkDownloadItem[data-year="${_esgDownload.year}"]:lt(${_max}):gt(${_min}):even`).addClass('odd').show();
        $(`.bkDownloadItem[data-year="${_esgDownload.year}"]:lt(${_max}):gt(${_min}):odd`).addClass('even').show();
    }
    _g.aost4.update();
    _esgDownload.pageGenerate(_esgDownload.pageNow);
}

_esgDownload.pageGenerate = function(position){
    const pageG = new PageGenerate(_esgDownload.pageCount,position);
    $('.bkDownloadPage').html(pageG.html);
    $(`.bkDownloadPage .bkPage[data-page="${_esgDownload.pageNow}"]`).addClass('active');
    _esgDownload.bindBtn();
}

_esgDownload.bindBtn = function(){
    _esgDownload.pagePrev();
    _esgDownload.pageNext();
    _esgDownload.pageClick();
}

////////////////////////////////////////////////////



$(function () {
    _esgAward.init();
    // _esgArticle.pageInit();
    detectOrientation()
    _esgDownload.pageInit();
});

function detectOrientation() {
    if (window.orientation === 0 && window.innerWidth < 767) {
        _esgArticle.pageNow = 1;
        _esgArticle.pagination = _esgArticle.paginationMob;
        _esgArticle.pageInit();
    } else {
        _esgArticle.pageNow = 1;
        _esgArticle.pagination = _esgArticle.paginationDesk;
        _esgArticle.pageInit();
    }
}
window.addEventListener('orientationchange', detectOrientation);
